// extracted by mini-css-extract-plugin
export var fileUpload = "_g6-1";
export var modalButton = "_g6-0";